import { BriefcaseLineIcon, FlagLineIcon, UserCheckLineIcon } from '@/shared/ui/icons';

export const RESOURCE_AUDIENCE_ICONS = [FlagLineIcon, UserCheckLineIcon, BriefcaseLineIcon];
